/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/Meeting';
export default {
  date: 'Fecha',
  time: 'Hora',
  hours: '{howMany}h',
  minutes: '{howMany}min',
  today: 'Hoy',
  duration: 'Duración',
  topic: 'Nombre de la reunión',
  voIPOnly: 'Solo audio de internet',
  telephonyOnly: 'Solo teléfono',
  both: 'Teléfono y audio de internet',
  thirdParty: 'Audio de terceros',
  meetingId: 'ID de reunión',
  password: 'Contraseña',
  video: 'Vídeo',
  audio: 'Audio',
  scheduleFor: 'Programar en nombre de',
  [ASSISTED_USERS_MYSELF]: 'Mí',
  meetingOptions: 'Opciones de reunión',
  meetingSettings: 'Configuración de la reunión',
  rcMeetingSettings: 'Configuración de la reunión de vídeo',
  audioOptions: 'Opciones de audio',
  recurringMeeting: 'Reunión recurrente',
  recurringNote: 'Nota: Habilite esta opción al elegir la recurrencia.',
  joinBeforeHost: 'Permitir a los participantes unirse antes que el host',
  turnOffCamera: 'Desactivar la cámara para los participantes',
  turnOffHostCamera:
    'Desactivar la cámara del organizador al unirse a la reunión',
  requirePassword: 'Solicitar contraseña',
  enterPassword: 'Introducir contraseña',
  setPassword: 'Establecer contraseña *',
  passwordEmptyError: 'Contraseña de la reunión obligatoria',
  rcmPasswordInvalidError:
    'La contraseña debe tener un máximo de 10 caracteres o números y no puede incluir símbolos, excepto “@”, “*” o “-”.',
  rcmPasswordHintText:
    'La contraseña debe tener un máximo de 10 caracteres o números y no puede incluir símbolos, excepto “@”, “*” o “-”.',
  usePersonalMeetingId: 'Utilizar ID de reunión personal',
  pmiChangeConfirm: 'Si desea realizar cambios en su reunión personal, ',
  changePmiSettings: 'modifique la configuración del PMI.',
  pmiSettingChangeAlert:
    'Si modifica la configuración y programa esta reunión, todas las reuniones con ID de reunión personal usarán la configuración más reciente.',
  lockedTooltip:
    'Esta configuración la gestiona el administrador de su empresa',
  when: 'Cuándo',
  recurringDescribe:
    'Recuerde comprobar la periodicidad o repetición en la invitación de calendario enviada a los asistentes.',
} as const;

// @key: @#@"date"@#@ @source: @#@"Date"@#@
// @key: @#@"time"@#@ @source: @#@"Time"@#@
// @key: @#@"hours"@#@ @source: @#@"{howMany} hr"@#@
// @key: @#@"minutes"@#@ @source: @#@"{howMany} min"@#@
// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"duration"@#@ @source: @#@"Duration"@#@
// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
// @key: @#@"voIPOnly"@#@ @source: @#@"Internet audio only"@#@
// @key: @#@"telephonyOnly"@#@ @source: @#@"Telephone only"@#@
// @key: @#@"both"@#@ @source: @#@"Telephone and Internet audio"@#@
// @key: @#@"thirdParty"@#@ @source: @#@"3rd party audio"@#@
// @key: @#@"meetingId"@#@ @source: @#@"Meeting ID"@#@
// @key: @#@"password"@#@ @source: @#@"Password"@#@
// @key: @#@"video"@#@ @source: @#@"Video"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"meetingOptions"@#@ @source: @#@"Meeting options"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"rcMeetingSettings"@#@ @source: @#@"Video Meeting settings"@#@
// @key: @#@"audioOptions"@#@ @source: @#@"Audio options"@#@
// @key: @#@"recurringMeeting"@#@ @source: @#@"Recurring meeting"@#@
// @key: @#@"recurringNote"@#@ @source: @#@"Note: Enable this one when choosing \"Recurrence\""@#@
// @key: @#@"joinBeforeHost"@#@ @source: @#@"Allow participants to join before host"@#@
// @key: @#@"turnOffCamera"@#@ @source: @#@"Turn off camera for participants"@#@
// @key: @#@"turnOffHostCamera"@#@ @source: @#@"Turn off camera for host when joining meeting"@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"setPassword"@#@ @source: @#@"Set password *"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"rcmPasswordInvalidError"@#@ @source: @#@"Your password must be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"rcmPasswordHintText"@#@ @source: @#@"Your password should be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"usePersonalMeetingId"@#@ @source: @#@"Use Personal Meeting ID"@#@
// @key: @#@"pmiChangeConfirm"@#@ @source: @#@"If you want to make changes for your Personal Meeting, "@#@
// @key: @#@"changePmiSettings"@#@ @source: @#@"change PMI settings"@#@
// @key: @#@"pmiSettingChangeAlert"@#@ @source: @#@"If you change the settings and schedule this meeting, all of meetings with Personal Meeting ID will use the same latest settings."@#@
// @key: @#@"lockedTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"when"@#@ @source: @#@"When"@#@
// @key: @#@"recurringDescribe"@#@ @source: @#@"Please remember to check recurrence or repeat in your calendar invitation to your attendees."@#@
